import { prepActions } from "~/hocs/crud";
import { service } from "./service";
import customerSagas from "./sagas";

const actions = prepActions(service);
export { actions, customerSagas };
